export default __webpack_public_path__ + "static/media/bake.839f00c2.png";